import {config} from '../../../config'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import _ from 'lodash'
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import axios from 'axios'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'

const EditAbout = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [aboutlist, setAboutList] = useState([])

  const navigate = useNavigate()
  useEffect(() => {
    getAbout()
    getAboutEdit()
  }, [])

  const [title, setTitle] = useState('')

  const [content, setContent] = useState('')

  const [members, setMembers] = useState('')
  const [foundation, setFoundation] = useState('')
  const [customers, setCustomers] = useState('')
  const [orders, setOrders] = useState('')
  const [image, setImage] = useState('')

  const [imagepreview, setImagepreview] = useState('')
  const [imagede, setImagede] = useState('')
  const [editimg, setImageedit] = useState('')

  const [updateid, setUpdateid] = useState('')
  const [error, setError] = useState(false)
  const params = useParams()

  const getAbout = async () => {
    let aboutresult = await fetch(config.apiurl + '/aboutus/get_about')
    aboutresult = await aboutresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setAboutList(aboutresult?.data?.results)
  }

  const getAboutEdit = async () => {
    let proeditdetails = await fetch(
      config.apiurl + '/aboutus/' + params.editid,
      {
        method: 'get',
        headers: {
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
    )
    proeditdetails = await proeditdetails.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))

    setTitle(proeditdetails?.data?.[0]?.title)
    setContent(proeditdetails?.data?.[0]?.content)
    setMembers(proeditdetails?.data?.[0]?.members)
    setFoundation(proeditdetails?.data?.[0]?.foundation)
    setCustomers(proeditdetails?.data?.[0]?.customers)
    setOrders(proeditdetails?.data?.[0]?.orders)
    setImageedit(proeditdetails?.data?.[0]?.image)
    setImage(proeditdetails?.data?.[0]?.image)
    if (params) {
      setImagepreview(config.fileurl + proeditdetails?.data?.[0]?.image)
    }
  }

  const handleImageupload = async (event) => {
    const fileup = event.target.files[0]
    Transformfile(fileup)
  }

  const Transformfile = (file) => {
    const reader = new FileReader()
    if (file) {
      reader.readAsDataURL(file)
      reader.onloadend = () => {
        setImage(file.name)
        setImagepreview(reader.result)
        setImagede(file)
      }
    } else {
      setImage('')
      setImagepreview('')
      setImagede('')
    }
  }

  const submitProductDetails = async (res) => {
    const editupdateurl = config.apiurl + '/aboutus/' + params.editid
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }

    const ondataSuccess = (response) => {
      if (response?.data?.status?.toLowerCase() === 'true') {
        toast('Updated successfully')
        setTimeout(() => {
          navigate('/about')
        }, 2000)
      }
    }
    const ondataFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    const editdata = {
      title: title,
      content: content,
      members: members,
      foundation: foundation,
      customers: customers,
      orders: orders,
      image: res,
    }
    axios
      .put(editupdateurl, editdata, configdata)
      .then(ondataSuccess, ondataFailure)
  }

  const handleProsubmit = async () => {
    if(!title?.trim() ||
      !content?.trim() ||
      !members ||
      !orders ||
      !foundation ||
      !customers ||
      !image?.trim()
      ){
        setError(true);
        return;
    }
   
    /*Image Upload process here */
    if (imagede) {
      const imageupurl = config.apiurl + '/upload/upload-single'
      const configimg = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'bearer ' + accesstoken.data.access_token,
        },
      }
      const formData = new FormData()
      formData.append('file', imagede)

      const onSuccess = (response) => {
        submitProductDetails(response.data.data.filename)
      }
      const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
      axios.post(imageupurl, formData, configimg).then(onSuccess, onFailure)
    } else {
      submitProductDetails(editimg)
    }
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Edit About Page</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Title
                        </label>

                        <input
                          className="form-control"
                          type="text"
                          value={title}
                          onChange={(e) => {
                            setTitle(e.target.value)
                          }}
                        />

                        {error && !title?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the title
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Customers
                        </label>

                        <input
                          className="form-control"
                          type="number"
                          value={customers}
                          onChange={(e) => {
                            setCustomers(e.target.value)
                          }}
                        />

                        {error && !customers && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the customers count
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Orders
                        </label>
                        <input
                          className="form-control"
                          type="number"
                          value={orders}
                          onChange={(e) => {
                            setOrders(e.target.value)
                          }}
                        />
                        {error && !orders && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the monthly orders count
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Members
                        </label>

                        <input
                          className="form-control"
                          type="number"
                          value={members}
                          onChange={(e) => {
                            setMembers(e.target.value)
                          }}
                        />

                        {error && !members && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the members count
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Foundation
                        </label>

                        <input
                          className="form-control"
                          type="number"
                          value={foundation}
                          onChange={(e) => {
                            setFoundation(e.target.value)
                          }}
                        />

                        {error && !foundation && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the foundation
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file" accept="image/png, image/jpeg"
                          onChange={(event) => handleImageupload(event)}
                        />
                          {error && !imagepreview && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Choose the image
                          </span>
                        )}
                      </div>
                    </div>
                    {imagepreview ? (
                      <div className="col-md-6">
                        {<img src={imagepreview} width="150" height="150" />}
                      </div>
                    ) : null}
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Content
                        </label>
                        <textarea
                          className="form-control"
                          rows="5"
                          value={content}
                          onChange={(e) => {
                            setContent(e.target.value)
                          }}
                        ></textarea>
                        {error && !content?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the content
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row"> 
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={handleProsubmit}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default EditAbout
